import "./App.css";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Layout from "./pages/layout";
import NotFound from "./pages/not-found";
import Vision from "./pages/ai-magic-studio/magics/vision";
import VisionCreate from "./pages/ai-magic-studio/magics/vision-create";
import VisionTraining from "./pages/ai-magic-studio/magics/vision-training";
import Document from "./pages/ai-magic-studio/magics/document";
import SiteManagement from "./pages/site-management";
import UserManagement from "./pages/user-management/user-management";
import AIMagicStudio from "./pages/ai-magic-studio/magics/ai-magic-studio";
import AILogicStudio from "./pages/ai-logic-studio/ai-logic-studio";
import PlanAndBilling from "./pages/plan-and-billing";
import Speech from "./pages/ai-magic-studio/magics/speech";
import Text from "./pages/ai-magic-studio/magics/text";
import DocumentCreate from "./pages/ai-magic-studio/magics/document-create";
import Login from "./pages/login";
import Domain from "./pages/domain";
import CreateNewUser from "./pages/user-management/create-new-user";
import AIMagixContainer from "./pages/ai-magic-studio/ai-magix-container/ai-magix-container";
import CreateContainerWrapper from "./pages/ai-magic-studio/ai-magix-container/create-container-wrapper";
import ContainerWrapper from "./pages/ai-magic-studio/ai-magix-container/container-wrapper";
import CreateProcessWrapper from "./pages/ai-logic-studio/create-process-wrapper";
import ProcessWrapper from "./pages/ai-logic-studio/process-wrapper";
import ErrorPopup from "./components/UI/error-popup";
import { useMemo, useState } from "react";
import PageLoader from "./components/UI/page-loader";
import Process from "./pages/process/process";
import RemoteMonitoring from "./pages/remote-monitoring/remote-monitoring";
import MasterDetails from "./pages/master-details/master-details";
import UserMaster from "./pages/user-master/user-master";
import AISubLogicStudioWrapper from "./pages/ai-logic-studio/ai-sub-logic-studio-wrapper";
import MasterDetailsDetail from "./pages/master-details/master-details-detail";
import "react-loading-skeleton/dist/skeleton.css";
import MappingWrapper from "./pages/ai-logic-studio/mapping-wrapper";
import NewSurveyWrapper from "./pages/ai-logic-studio/new-survey-wrapper";
import NewGetStartedWrapper from "./pages/ai-logic-studio/new-get-started-wrapper";
import NewSubProcessWrapper from "./pages/ai-logic-studio/new-sub-process-wrapper";
import CreateMasterDetailsWrapper from "./pages/master-details/create-master-details-wrapper";
import CreateUserMasterWrapper from "./pages/user-master/create-user-master-wrapper";
import CreateMasterDetailsDetailWrapper from "./pages/master-details/create-master-details-detail-wrapper";
import { SkeletonTheme } from "react-loading-skeleton";
import React from "react";
import ThemeHandler from "./lib/theme-handler";
import RequireAuth from "./auth/RequireAuth"; // Import your authentication HOC
import { AuthProvider } from "./auth/AuthContext";
import ResetPassword from "./pages/reset-password";
import Dashboard from "./pages/dashboard";
import CreateInspectionWrapper from "./pages/process/create-inspection-wrapper";
import ReactDashboardUI from "./pages/dashboard-ui/react-dashboard-ui";
import PageNotFound from "./pages/page-not-found";
import SplitDashboard from "./pages/dashboard-ui/splitDashboard";
import RemoteMonitoringView from "./pages/remote-monitoring/remote-monitoring-view";
import LiveDashboard from "./pages/live-dashboard/live-dashboard";
const VisionTrainingPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <VisionTraining
      iteration={location.state?.iteration ?? 0}
      magicCommonData={{ uniqueId: id, ...(location.state?.magicCommonData ?? {}) }}
      handleEditorClose={() => navigate(-1)}
    />
  );
};

interface DependentValue {
  value: string;
}
interface DependentDataItem {
  uniqueId: string;
  dependentValues: DependentValue[];
}
function App() {
  const [isServerError, setIsServerError] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isConfetti, setIsConfetti] = useState<boolean>(false);
  const [logicUpdated, setLogicUpdated] = useState<any>(undefined);
  const [processUpdated, setProcessUpdated] = useState<any>(undefined);
  const [surveyUpdated, setSurveyUpdated] = useState<any>(undefined);
  const [userUpdated, setUserUpdated] = useState<any>(undefined);
  const [headerDetails, setHeaderDetails] = useState<any>(undefined);
  const [accessQueryDetails, setAccessQueryDetails] = useState<any>(undefined);
  const [dependentData, setDependentData] = useState<any>(undefined);
  const [visionUpdated, setVisionUpdated] = useState<any>(undefined);
  const [containerUpdated, setContainerUpdated] = useState<any>(undefined);
  const [subProcessUpdated, setSubProcessUpdated] = useState<any>(undefined);
  const [getStartedUpdated, setGetStartedUpdated] = useState<any>(undefined);
  const [masterDetailsUpdated, setMasterDetailsUpdated] =
    useState<any>(undefined);
  const [userMasterUpdated, setUserMasterUpdated] = useState<any>(undefined);
  const [userColumnUpdated, setUserColumnUpdated] = useState<any>(undefined);
  const [isThemeToggled, setIsThemeToggled] = useState<any>(false);

  const DashboardRoute = () => {
    const dashboardType = Number(sessionStorage.getItem("dashboardType") || "1");

    const getDashboardComponent = () => {
      switch (dashboardType) {
        case 3:
          return <SplitDashboard />;
        case 2:
          return <ReactDashboardUI />;
        case 1:
        default:
          return <Dashboard />;
      }
    };
    return <RequireAuth>{getDashboardComponent()}</RequireAuth>;
  };


  const router = createBrowserRouter([
    {
      path: "/domain",
      element: <Domain />,
      errorElement: <NotFound />,
    },
    {
      path: "/login",
      element: <Login />,
      errorElement: <NotFound />,
    },
    {
      path: "/reset-password",
      element: <ResetPassword />,
      errorElement: <NotFound />,
    },
    {
      path: "/page-not-found",
      element: <PageNotFound />,
    },
    {
      path: "",
      element: (
        <AuthProvider>
          <Layout
            confettiVal={isConfetti}
            themeToggled={() => setIsThemeToggled((pre: any) => !pre)}
          >
            <ThemeHandler
              setIsDarkMode={setIsDarkMode}
              isThemeToggled={isThemeToggled}
            />
          </Layout>
        </AuthProvider>
      ),
      errorElement: <NotFound />,
      children: [
        {
          index: true,
          element: <Navigate to={"/login"} />,
        },
        {
          path: "dashboard",
          element: <DashboardRoute />,
        },
        {
          path: "site-management",
          element: (
            <RequireAuth>
              <SiteManagement />
            </RequireAuth>
          ),
        },
        {
          path: "user-management",
          element: (
            <RequireAuth>
              <UserManagement
                userUpdated={userUpdated}
                setUserUpdated={(val: any) => setUserUpdated(val)}
              />
            </RequireAuth>
          ),
          children: [
            {
              path: "user/:id",
              element: (
                <RequireAuth>
                  <CreateNewUser
                    navigateLink="/user-management"
                    userUpdated={() => setUserUpdated((pre: any) => !pre)}
                  />
                </RequireAuth>
              ),
            },
          ],
        },
        {
          path: "master-details",
          element: (
            <RequireAuth>
              <MasterDetails
                masterDetailsUpdated={masterDetailsUpdated}
                setMasterDetailsUpdated={(val: any) =>
                  setMasterDetailsUpdated(val)
                }
              />
            </RequireAuth>
          ),
          children: [
            {
              path: "new-master-details/:id",
              element: (
                <RequireAuth>
                  <CreateMasterDetailsWrapper
                    masterDetailsUpdated={() =>
                      setMasterDetailsUpdated((pre: any) => !pre)
                    }
                  />
                </RequireAuth>
              ),
            },
            {
              path: "user-master/:tableId",
              element: (
                <RequireAuth>
                  <UserMaster
                    setHeaderDetails={setHeaderDetails}
                    setAccessQueryDetails={setAccessQueryDetails}
                    userMasterUpdated={userMasterUpdated}
                    setUserMasterUpdated={(val: any) =>
                      setUserMasterUpdated(val)
                    }
                    setDependentData={setDependentData}
                  />
                </RequireAuth>
              ),
              children: [
                {
                  path: "user-master-new/:id",
                  element: (
                    <RequireAuth>
                      <CreateUserMasterWrapper
                        headerDetails={headerDetails}
                        accessQueryDetails={accessQueryDetails}
                        userMasterUpdated={() =>
                          setUserMasterUpdated((pre: any) => !pre)
                        }
                        dependentData={dependentData}
                      />
                    </RequireAuth>
                  ),
                },
              ],
            },
            {
              path: "detail/:id",
              element: (
                <RequireAuth>
                  <MasterDetailsDetail
                    userColumnUpdated={userColumnUpdated}
                    setUserColumnUpdated={(val: any) =>
                      setUserColumnUpdated(val)
                    }
                  />
                </RequireAuth>
              ),
              children: [
                {
                  path: "new-master-details/:id",
                  element: (
                    <RequireAuth>
                      <CreateMasterDetailsDetailWrapper
                        userColumnUpdated={() =>
                          setUserColumnUpdated((pre: any) => !pre)
                        }
                      />
                    </RequireAuth>
                  ),
                },
              ],
            },
          ],
        },
        {
          path: "user-master/:tableId",
          element: (
            <UserMaster
              setHeaderDetails={setHeaderDetails}
              setAccessQueryDetails={setAccessQueryDetails}
              setDependentData={setDependentData}
            />
          ),
          children: [
            {
              path: "user-master-new/:id",
              element: (
                <RequireAuth>
                  <CreateUserMasterWrapper
                    headerDetails={headerDetails}
                    accessQueryDetails={accessQueryDetails}
                    dependentData={dependentData}
                  />
                </RequireAuth>
              ),
            },
          ],
        },
        {
          path: "ai-magic-studio",
          element: <AIMagicStudio />,
          children: [
            {
              index: true,
              element: <Navigate to={"/ai-magic-studio/vision/:magicType"} />,
            },
            {
              path: "vision/:magicType",
              element: (
                <Vision
                  visionUpdated={visionUpdated}
                  setVisionUpdated={(val: any) => setVisionUpdated(val)}
                />
              ),
              children: [
                {
                  path: "create/:id",
                  element: (
                    <VisionCreate
                      navigateLink="/user-management"
                      visionUpdated={() => setVisionUpdated((pre: any) => !pre)}
                      setIsConfetti={setIsConfetti}
                    />
                  ),
                },
                {
                  path: "training/:id",
                  element: <VisionTrainingPage />,
                },
              ],
            },
            {
              path: "document",
              element: <Document />,
              children: [
                {
                  path: "create",
                  element: <DocumentCreate />,
                },
              ],
            },
            {
              path: "speech",
              element: <Speech />,
            },
            {
              path: "text",
              element: <Text />,
            },
          ],
        },
        {
          path: "ai-magix-container",
          element: (
            <AIMagixContainer
              containerUpdated={containerUpdated}
              setContainerUpdated={(val: any) => setContainerUpdated(val)}
            />
          ),
          children: [
            {
              path: "magix-container/:id",
              element: (
                <CreateContainerWrapper
                  navigateLink="/ai-magix-container"
                  containerUpdated={() =>
                    setContainerUpdated((pre: any) => !pre)
                  }
                />
              ),
            },
            {
              path: "container/:id",
              element: <ContainerWrapper />,
            },
          ],
        },
        {
          path: "ai-logic-studio",
          element: (
            <AILogicStudio
              logicUpdated={logicUpdated}
              setLogicUpdated={(val: any) => setLogicUpdated(val)}
            />
          ),
          children: [
            {
              path: "new-process-logic/:id",
              element: (
                <CreateProcessWrapper
                  navigateLink="/ai-logic-studio"
                  logicUpdated={() => setLogicUpdated((pre: any) => !pre)}
                />
              ),
            },
            {
              path: "process-logic/:logicId",
              element: (
                <AISubLogicStudioWrapper
                  surveyUpdated={surveyUpdated}
                  getStartedUpdated={getStartedUpdated}
                  subProcessUpdated={subProcessUpdated}
                  setSurveyUpdated={(val: any) => setSurveyUpdated(val)}
                  setSubProcessUpdated={(val: any) => setSubProcessUpdated(val)}
                  setGetStartedUpdated={(val: any) => setGetStartedUpdated(val)}
                />
              ),
              children: [
                {
                  path: "survey/:id",
                  element: <ProcessWrapper />,
                },
                {
                  path: "new-survey/:surveyId",
                  element: (
                    <NewSurveyWrapper
                      navigateLink="/ai-logic-studio"
                      surveyUpdated={(val: any) => setSurveyUpdated(val)}
                    />
                  ),
                },
                {
                  path: "get-started/:id",
                  element: <ProcessWrapper />,
                },
                {
                  path: "new-get-started/:id",
                  element: (
                    <NewGetStartedWrapper
                      navigateLink="/ai-logic-studio"
                      getStartedUpdated={(val: any) =>
                        setGetStartedUpdated(val)
                      }
                    />
                  ),
                },
                {
                  path: "mapping/:id",
                  element: <MappingWrapper />,
                },
                {
                  path: "new-sub-process/:id",
                  element: (
                    <NewSubProcessWrapper
                      navigateLink="/ai-logic-studio"
                      subProcessUpdated={(val: any) =>
                        setSubProcessUpdated(val)
                      }
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: "process",
          element: (
            <Process
              processUpdated={processUpdated}
              setProcessUpdated={(val: any) => setProcessUpdated(val)}
            />
          ),
          // children: [
          //   {
          //     path: "new-process-logic",
          //     element: (
          //       <CreateInspectionWrapper
          //         navigateLink="/process"
          //         processUpdated={() => setProcessUpdated((pre: any) => !pre)}
          //       />
          //     ),
          //   },
          // ],
        },
        {
          path: "remote-monitoring",
          element: (
            <RemoteMonitoring
              userUpdated={userUpdated}
              setUserUpdated={(val: any) => setUserUpdated(val)}
            />
          ), children: [{
            path: "remote-monitoring-view",
            element: <RemoteMonitoringView />,
          },],
        },
        {
          path: "plan-and-billing",
          element: <PlanAndBilling />,
        },
        {
          path: "live-dashboard",
          element: <LiveDashboard />,
        },
        {
          path: "*",
          element: <PageNotFound />,
        },
      ],
    },
  ]);
  return (
    <>
      <SkeletonTheme
        baseColor={isDarkMode === true ? "#232432" : "#ebebeb"}
        highlightColor={isDarkMode === true ? "#484952" : "#f5f5f5"}
      >
        <RouterProvider router={router}></RouterProvider>
      </SkeletonTheme>
      {isServerError && (
        <ErrorPopup handleClose={() => setIsServerError(false)} />
      )}
      {pageLoader && <PageLoader />}
    </>
  );
}

export default App;
